import { createApp } from 'vue'
import App from '@/page/vue/2023/618.vue'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
  title: '抢早鸟钜惠！ISC 2023抢票通道正式开启',
  desc: '8.9-8.10 北京国家会议中心',
  imgUrl: 'https://p3.ssl.qhimg.com/t0141d5d993b0592358.png',
  link: window.location.href
})

const app = createApp(App)
app.mount('#app')
